import {env,edition} from '@/common/config.js'

const environment = {
    data() {
        return {
            env,
            edition
        }
    },
    methods: {
      
    }
}

export default environment